module.exports = __webpack_public_path__ + "static/media/logoGreen.9a4a6810.svg";